import { render } from "./AppTopbar.vue?vue&type=template&id=047725ae&scoped=true"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=047725ae&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047725ae"]])

export default __exports__